import { useState } from 'react';
import { Link } from 'react-router-dom';
import { rankings, comics, categories } from '@/mocks/comics';

type RankTab = 'popularity' | 'rating' | 'trending';

const tabLabels: Record<RankTab, string> = {
  popularity: '人气榜',
  rating: '评分榜',
  trending: '趋势榜',
};

export default function RankingSection() {
  const [tab, setTab] = useState<RankTab>('popularity');
  const list = rankings[tab].map((id) => comics.find((c) => c.id === id)!);

  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between mb-8 gap-4">
            <div>
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
                排行榜
              </h2>
              <p className="text-sm text-foreground-500 mt-1">全站漫画数据实时排行</p>
            </div>
            <div className="flex items-center gap-1 bg-background-200/60 rounded-full p-1">
              {(Object.keys(tabLabels) as RankTab[]).map((key) => (
                <button
                  key={key}
                  onClick={() => setTab(key)}
                  className={`px-4 py-1.5 text-sm font-medium rounded-full transition-all whitespace-nowrap ${
                    tab === key
                      ? 'bg-primary-500 text-background-50'
                      : 'text-foreground-600 hover:text-foreground-900'
                  }`}
                >
                  {tabLabels[key]}
                </button>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
            {list.map((comic, idx) => (
              <Link
                key={comic.id}
                to={`/comic/${comic.id}`}
                className="flex items-center gap-4 p-4 rounded-xl bg-background-50 hover:bg-background-50/80 transition-colors group"
              >
                <span className={`text-lg font-bold w-8 h-8 flex items-center justify-center rounded-lg flex-shrink-0 ${
                  idx === 0
                    ? 'bg-accent-500 text-background-50'
                    : idx === 1
                    ? 'bg-accent-400 text-background-50'
                    : idx === 2
                    ? 'bg-accent-300 text-background-50'
                    : 'bg-background-100 text-foreground-500'
                }`}>
                  {idx + 1}
                </span>
                <div className="w-12 h-16 rounded-md overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={comic.cover}
                    alt={comic.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <h4 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                    {comic.title}
                  </h4>
                  <div className="flex items-center gap-2 mt-1">
                    <span className="text-xs text-foreground-500">{comic.author}</span>
                    <span className="text-xs px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-700">
                      {categories.find((c) => c.slug === comic.category)?.name}
                    </span>
                  </div>
                </div>
                <div className="flex items-center gap-1 flex-shrink-0">
                  <i className="ri-star-fill text-accent-500 text-sm"></i>
                  <span className="text-sm font-semibold text-foreground-700">{comic.rating}</span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}